import { Action, combineReducers, configureStore } from "@reduxjs/toolkit";
import thunk, { ThunkMiddleware } from "redux-thunk";
import { IShipmentSelectorState, ShipmentSelectorReducer } from "./ShipmentSelectorReducer";

const shipmentSelectorRootReducer = combineReducers({
	ShipmentSelector: ShipmentSelectorReducer,
});

export type ShipmentSelectorRootState = ReturnType<typeof shipmentSelectorRootReducer>;


export interface DispatchAction extends Action {
	payload: Partial<IShipmentSelectorState>;
}

const middleware = thunk as ThunkMiddleware<ShipmentSelectorRootState, DispatchAction>;

export const shipmentSelectorStore = configureStore({
	reducer: shipmentSelectorRootReducer,
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware().concat(middleware),
});
